import { render } from "./pages.vue?vue&type=template&id=6d783428&scoped=true"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"

import "./pages.vue?vue&type=style&index=0&id=6d783428&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d783428"]])

export default __exports__